import React from "react";
import * as Datetime from "react-datetime";
import { FormField } from ".";
import { ValidatedFormFieldBase } from "../validation";
import * as moment from "moment";

interface OwnProps {
    className?: string;
    dateFormat?: string;
    datePlaceholder?: string;
    inputClassName?: string;
    timeFormat?: string;
    timePlaceholder?: string;
    viewDate?: Date | string | moment.Moment;
    viewMode?: Datetime.ViewMode | number;
}

interface OwnState {
    dateOpen: boolean;
    timeOpen: boolean;
}

export class DateAndTimePickerField extends ValidatedFormFieldBase<OwnProps, OwnState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dateOpen: false,
            timeOpen: false,
        };
    }

    public render() {
        const dateFormat = this.props.dateFormat || "MM/DD/YYYY";
        const timeFormat = this.props.timeFormat || "h:mm a";
        const label = this.getLabel(this.props.label);
        const value: Date | null | undefined = this.getValue() as Date;

        return <FormField {...this.props} errors={this.getErrors()} label={label} name={this.props.name} required={this.isRequired(this.props.required)}>
            <div className="datetime-field">
                <input
                    type="hidden"
                    name={this.props.name}
                    onChange={() => {}}
                    value={value ? moment(value).format("MM/DD/YYYY HH:mm") : ""}
                />

                <Datetime
                    className={this.props.className}
                    closeOnSelect
                    dateFormat={dateFormat}
                    onBlur={() => this.props.formComponent.triggerBlur(this.props.name)}
                    onChange={(date) => this.handleDateChange(date)}
                    inputProps={{
                        className: this.props.inputClassName || "txt-date",
                        placeholder: this.props.datePlaceholder !== undefined ? this.props.datePlaceholder : "mm/dd/yyyy",
                        // value: value ? moment(value).format(dateFormat) : "",
                    }}
                    timeFormat={false}
                    value={value ? moment(value) : undefined}
                    viewDate={this.props.viewDate}
                    viewMode={this.props.viewMode}
                />

                <Datetime
                    className={this.props.className}
                    closeOnSelect
                    dateFormat={false}
                    onBlur={() => this.props.formComponent.triggerBlur(this.props.name)}
                    onChange={(date) => this.handleTimeChange(date)}
                    inputProps={{
                        className: this.props.inputClassName || "txt-date",
                        placeholder: this.props.timePlaceholder !== undefined ? this.props.timePlaceholder : "hh:mm",
                        // value: value && moment(value).startOf("day").valueOf() !== value.valueOf()
                        //     ? moment(value).format(timeFormat)
                        //     : "",
                    }}
                    timeFormat={timeFormat}
                    value={value && moment(value).startOf("day").valueOf() !== value.valueOf() ? moment(value) : ""}
                    viewDate={this.props.viewDate}
                    viewMode={this.props.viewMode}
                />
            </div>
        </FormField>;
    }

    private handleDateChange(date: string | moment.Moment) {
        if (typeof date === "string") {
            if (!date)
                this.props.formComponent.setFieldValue(this.props.name, null, undefined, () => this.props.formComponent.triggerBlur(this.props.name));
            return;
        }

        const m = moment(date);

        if (!m.isValid()) {
            this.props.formComponent.setFieldValue(this.props.name, null);
            return;
        }

        const dateVal = this.props.formComponent.getFieldValue(this.props.name) as Date | undefined | null;
        const newDate = m.startOf("day");

        // add existing time
        if (newDate && dateVal) {
            const timeMoment = moment(dateVal);
            newDate
                .add(timeMoment.hours(), "hours")
                .add(timeMoment.minutes(), "minutes");
        }

        this.props.formComponent.setFieldValue(this.props.name, newDate.toDate(), undefined, () => {
            this.props.formComponent.triggerBlur(this.props.name);
        });
    }

    private handleTimeChange(time: string | moment.Moment) {
        if (!time)
            time = moment().startOf("day");

        if (typeof time === "string")
            return;

        const m = moment(time);

        let dateVal = this.props.formComponent.getFieldValue(this.props.name) as Date | undefined | null;
        if (!dateVal)
            dateVal = new Date();

        const dateMoment = moment(dateVal).startOf("day");
        const newDate = m.isValid()
            ? dateMoment
                .add(m.hours(), "hours")
                .add(m.minutes(), "minutes")
                .toDate()
            : dateMoment;

        this.props.formComponent.setFieldValue(this.props.name, newDate, undefined, () => {
            this.props.formComponent.triggerBlur(this.props.name);
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/DateAndTimePickerField.tsx